import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-500 to-teal-400 text-white">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-2xl mb-8">Page Not Found</p>
      <Link to="/" className="bg-white text-blue-500 hover:text-blue-700 font-semibold py-2 px-4 rounded-lg shadow-lg transition-all duration-300">
        Go to Home
      </Link>
    </div>
  );
}

export default NotFound;